import React, { useState, useEffect } from "react";

//custom libraries
import handleApiError from "../helpers/handleApiError";

//third party libraries
import { useHistory, useParams } from "react-router-dom";

//services
import { getClaim } from "../services/claimService";
import { defaultTitle } from "../config";
import { Helmet } from "react-helmet";
import ViewClaimRework from "./ViewClaimRework";
const ViewClaim = ({ setLoading }) => {
  //CONSTANTS
  const { id: claimId } = useParams();
  const history = useHistory();

  const [claim, setClaim] = useState();

  //EFFECTS
  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const { data: foundClaim } = await getClaim(claimId);

        setClaim(foundClaim);

        setLoading(false);
      } catch (ex) {
        setLoading(false);
        handleApiError(ex, history);
      }
    })();
  }, [claimId, history, setLoading]);

  return (
    <React.Fragment>
      <Helmet>
        {/* // th is is the part of the claim formating  */}
        <title>Claim - {defaultTitle}</title>
      </Helmet>
      <ViewClaimRework setLoading={setLoading} /> <br />
      {/* <div className="paper-main-claims delivery-concern-page view-claim">
        <h1>Claim</h1>
        {claim && (
          <React.Fragment>
            {/* <table style={{maxWidth:700}} className='table table-sm'>
                        <tr>
                            <td>Received On</td>
                            <td>{claim.recDate}</td>
                        </tr>
                        <tr>
                            <td>Dealer</td>
                            <td>{claim.dealer}</td>
                        </tr>
                        <tr>
                            <td>Claim Number</td>
                            <td>{claim.claimNo}</td>
                        </tr>
                        <tr>
                            <td>Invoice Number</td>
                            <td>{claim.invoice}</td>
                        </tr>
                        <tr>
                            <td>Ship Date</td>
                            <td>{claim.cDate}</td>
                        </tr>
                        <tr>
                            <td>Customer</td>
                            <td>{claim.customer}</td>
                        </tr>
                        <tr>
                            <td>Route</td>
                            <td>{claim.route}</td>
                        </tr>
                        <tr>
                            <td>Part Numbers</td>
                            <td>{claim.partNo}</td>
                        </tr>
                        <tr>
                            <td>Part Description</td>
                            <td>{claim.pDesc}</td>
                        </tr>
                        <tr>
                            <td>Check Number</td>
                            <td>{claim.checkNo}</td>
                        </tr>
                        <tr>
                            <td>Closed On</td>
                            <td>{claim.moded}</td>
                        </tr>
                        <tr>
                            <td>Claim Type</td>
                            <td>{claim.type}</td>
                        </tr>
                    </table> */}
      {/* <div></div>
            <table
              className="table table sm"
              style={{ paddingLeft: 20, paddingBottom: 10 }}
            >
              <tr>
                <td scope="col"> Recieved On </td>
                <td scope="col"> {claim.recDate} </td>
              </tr>
              <tr>
                <td scope="col"> Deadler </td>
                <td scope="col">{claim.dealer}</td>
              </tr>
              <tr>
                <td scope="col"> Dealer </td>
                <td scope="col"> {claim.claimNo} </td>
              </tr>
              <tr>
                <td scope="col">Claim Number</td>
                <td scope="col"> {claim.invoice} </td>
              </tr>
              <td scope="col">Invoice Number</td>
              <td scope="col">{claim.cDate} </td>
              <tr>
                <td scope="col">Ship Date</td>
                <td scope="col">{claim.customer}</td>
              </tr>
              <tr>
                <td scope="col">Customer</td>
                <td scope="col">{claim.route}</td>
              </tr>
              <tr>
                <td scope="col">Route</td>
                <td scope="col">{claim.partNo}</td>
              </tr>
              <tr>
                <td scope="col">Part Number</td>
                <td scope="col">{claim.partNo}</td>
              </tr>
              <tr>
                <td scope="col">Part Description</td>
                <td scope="col">{claim.pDesc}</td>
              </tr>
              <tr>
                <td scope="col">Check Number</td>
                <td scope="col">{claim.checkNo}</td>
              </tr>
              <tr>
                <td scope="col">Closed On</td>
                <td scope="col">{claim.checkNo}</td>
              </tr>
              <tr>
                <td scope="col">Claim Type</td>
                <td scope="col">{claim.type}</td>
              </tr>
            </table> */}
      {/* </th>
                        <dt className='col-sm-6'>Received On</dt>
                        <dd className='col-sm-6'>{claim.recDate}</dd>

                        <dt className='col-sm-6'>Dealer</dt>
                        <dd className='col-sm-6'>{claim.dealer}</dd>

                        <dt className='col-sm-6'>Claim Number</dt>
                        <dd className='col-sm-6'>{claim.claimNo}</dd>

                        <dt className='col-sm-6'>Invoice Number</dt>
                        <dd className='col-sm-6'>{claim.invoice}</dd>

                        <dt className='col-sm-6'>Ship Date</dt>
                        <dd className='col-sm-6'>{claim.cDate}</dd>

                        <dt className='col-sm-6'>Customer</dt>
                        <dd className='col-sm-6'>{claim.customer}</dd>

                        <dt className='col-sm-6'>Route</dt>
                        <dd className='col-sm-6'>{claim.route}</dd>

                        <dt className='col-sm-6'>Part Numbers</dt>
                        <dd className='col-sm-6'>{claim.partNo}</dd>

                        <dt className='col-sm-6'>Part Description</dt>
                        <dd className='col-sm-6'>{claim.pDesc}</dd>

                        <dt className='col-sm-6'>Check Number</dt>
                        <dd className='col-sm-6'>{claim.checkNo}</dd>

                        <dt className='col-sm-6'>Closed On</dt>
                        <dd className='col-sm-6'>{claim.moded}</dd>

                        <dt className='col-sm-6'>Claim Type</dt>
                        <dd className='col-sm-6'>{claim.type}</dd>
                    </dl> */}
      {/* <h2>Claim Status</h2>
            <div
              className="row"
              style={{ maxWidth: 400, paddingLeft: 20, paddingBottom: 0 }}
            >
              <table className="table table sm">
                <tr>
                  <td scope="col">
                    <div>
                      Approved
                      <br />
                      {claim.stat === "A" ? (
                        <input
                          type="checkbox"
                          checked={true}
                          onclick="return false;"
                        />
                      ) : (
                        <input
                          type="checkbox"
                          checked={false}
                          onclick="return false;"
                        />
                      )}
                    </div>
                  </td>

                  <td scope="col">
                    <div>
                      Denied
                      <br />
                      {claim.stat === "D" ? (
                        <input
                          type="checkbox"
                          checked={true}
                          onclick="return false;"
                        />
                      ) : (
                        <input
                          type="checkbox"
                          checked={false}
                          onclick="return false;"
                        />
                      )}
                    </div>
                  </td>
                  <td scope="col">
                    <div className="col">
                      Cancelled
                      <br />
                      {claim.stat === "C" ? (
                        <input
                          type="checkbox"
                          checked={true}
                          onclick="return false;"
                        />
                      ) : (
                        <input
                          type="checkbox"
                          checked={false}
                          onclick="return false;"
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  {" "}
                  <td scope="col"></td> <td scope="col"></td>
                  <td scope="col"></td>
                </tr>
              </table>
            </div>

            <h2>Comments</h2>
            <table
              style={{
                maxWidth: 389,
                paddingLeft: 20,
                paddingBottom: 20,
              }}
              className="table table sm"
            >
              <tr>
                <td scope="col">
                  <div>{claim.comment}</div>
                </td>
              </tr>
              <tr>
                <td scope="col"></td>
              </tr>
            </table>
            <h2>Claim Disclaimer</h2>
            <table className="table table sm">
              <tr>
                <td scope="col">
                  <p style={{ paddingBottom: 0 }}>
                    <ol>
                      <li>
                        Each claim must include a copy of the documentation
                        showing the manufacturer's cost, excluding taxes,
                        freight charges and restocking fees.
                      </li>
                      <li>
                        Customer should call Diligent at 877-886-6253 to
                        schedule a pick-up for the damaged freight.
                      </li>
                      <li>There should only be one claim form per shipment.</li>
                      <li>
                        Please email all claims to claims@Diligentusa.com or fax
                        to (713) 275-2523, Attention: Claims.
                      </li>
                      <li>Claim must be submitted within 15 business days.</li>
                    </ol>
                  </p>
                </td>
              </tr>
              <tr>
                <td scope="col"></td>
              </tr>
            </table> */}
    </React.Fragment>
    //  )}
    //  </div> */}
    //<br />
    // </React.Fragment>
  );
};

export default ViewClaim;
